export class EnableNewFeaturesInfo
{
    public ControllerId: number;
    public NewFeaturesButtonIsDisabled: boolean;
    public InfoText: string;

    constructor(controllerId: number, buttonIsDisabled: boolean, infoText: string)
    {
        this.ControllerId = controllerId;
        this.NewFeaturesButtonIsDisabled = buttonIsDisabled;
        this.InfoText = infoText;
    }
}
